import React from 'react';

const BhavaTable = ({ bhavaData }) => {
  if (!bhavaData || !Array.isArray(bhavaData)) {
    return <div className="text-white/50 text-center py-4">No bhava cusp data available</div>;
  }

  const convertDegToSign = (deg) => {
    const signs = ['Aries', 'Taurus', 'Gemini', 'Cancer', 'Leo', 'Virgo', 
                   'Libra', 'Scorpio', 'Sagittarius', 'Capricorn', 'Aquarius', 'Pisces'];
    return signs[Math.floor(deg / 30) % 12];
  };

  const formatDegree = (deg) => {
    const signDeg = deg % 30;
    const degrees = Math.floor(signDeg);
    const minutes = Math.floor((signDeg - degrees) * 60);
    return `${degrees}° ${minutes}'`;
  };

  return (
    <div className="w-full">
      <h3 className="text-cyan-400 text-lg font-medium mb-4">Bhava Cusps (House Boundaries)</h3>
      <div className="overflow-x-auto">
        <table className="w-full border-collapse">
          <thead>
            <tr className="bg-blue-900/30 border-b border-blue-700/50">
              <th className="text-left p-3 text-blue-300 font-medium">House</th>
              <th className="text-left p-3 text-blue-300 font-medium">Arambha (Start)</th>
              <th className="text-left p-3 text-blue-300 font-medium">Sign</th>
              <th className="text-left p-3 text-blue-300 font-medium">Madhya (Middle)</th>
              <th className="text-left p-3 text-blue-300 font-medium">Sign</th>
              <th className="text-left p-3 text-blue-300 font-medium">Antya (End)</th>
              <th className="text-left p-3 text-blue-300 font-medium">Sign</th>
            </tr>
          </thead>
          <tbody>
            {bhavaData.map((bhava, idx) => (
              <tr key={idx} className="border-b border-white/10 hover:bg-white/5 transition-colors">
                <td className="p-3 text-yellow-400 font-bold">House {bhava.house}</td>
                <td className="p-3 text-green-300 font-mono text-sm">{formatDegree(bhava.arambha_deg)}</td>
                <td className="p-3 text-cyan-300">{bhava.arambha_sign}</td>
                <td className="p-3 text-green-300 font-mono text-sm">{formatDegree(bhava.madhya_deg)}</td>
                <td className="p-3 text-cyan-300">{bhava.madhya_sign}</td>
                <td className="p-3 text-green-300 font-mono text-sm">{formatDegree(bhava.antya_deg)}</td>
                <td className="p-3 text-cyan-300">{bhava.antya_sign}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default BhavaTable;
